export default __webpack_public_path__ + "static/media/icon__dropdown.f492ca4e.svg";